import { useState } from "react";
import {
  MKButton,
  MKPopover,
  MKPopoverContent,
  MKPopoverTrigger,
} from "@mytraai/mytrakit";

interface Props {
  selectedCount: number;
  isProduction: boolean;
  onDeploy: () => Promise<void>;
}

export default function DeployButton({
  selectedCount,
  isProduction,
  onDeploy,
}: Props) {
  const [deploying, setDeploying] = useState(false);
  const [open, setOpen] = useState(false);

  const handleDeploy = async () => {
    setDeploying(true);
    try {
      await onDeploy();
      setOpen(false);
    } finally {
      setDeploying(false);
    }
  };

  const handleClick = () => {
    if (isProduction) {
      setOpen(true);
    } else {
      handleDeploy();
    }
  };

  if (selectedCount === 0) {
    return (
      <MKButton variant="brand" size="sm" disabled>
        Deploy
      </MKButton>
    );
  }

  if (!isProduction) {
    return (
      <MKButton
        variant="brand"
        size="sm"
        onClick={handleClick}
        disabled={deploying}
      >
        {deploying ? "Deploying..." : `Deploy (${selectedCount})`}
      </MKButton>
    );
  }

  return (
    <MKPopover open={open} onOpenChange={setOpen}>
      <MKPopoverTrigger asChild>
        <MKButton variant="brand" size="sm">
          Deploy ({selectedCount})
        </MKButton>
      </MKPopoverTrigger>
      <MKPopoverContent className="w-auto">
        <div className="space-y-3">
          <p className="text-sm text-content-secondary">
            Deploy {selectedCount} artifact{selectedCount !== 1 ? "s" : ""} to
            production?
          </p>
          <div className="flex gap-2">
            <MKButton
              onClick={() => setOpen(false)}
              disabled={deploying}
              variant="secondary"
              size="sm"
            >
              Cancel
            </MKButton>
            <MKButton
              onClick={handleDeploy}
              disabled={deploying}
              variant="brand"
              size="sm"
            >
              {deploying ? "Deploying..." : "Confirm"}
            </MKButton>
          </div>
        </div>
      </MKPopoverContent>
    </MKPopover>
  );
}
